<template>
  <div>
    <TableComponent
      :items="itemsFiltered"
      :loading="loading"
      @showDetails="showDetails"
      @showGroup="showGroup"
      :group="true"
    />

    <router-view @update="update" @showDetails="showDetails"></router-view>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { searchPerson } from "common/utils/people.js";
import TableComponent from "./TableComponent.vue";

export default defineComponent({
  name: "FinanceInvoicesSubmittedSap",
  components: {
    TableComponent,
  },
  props: ["search"],
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    itemsFiltered() {
      if (!this.search) {
        return this.items;
      }
      return this.items.filter(
        (el) =>
          el.number.toLowerCase().startsWith(this.search.toLowerCase()) ||
          (el.group &&
            el.group.number
              .toLowerCase()
              .startsWith(this.search.toLowerCase())) ||
          el.amount.toFixed(2) == parseFloat(this.search).toFixed(2) ||
          el.amountForeign.toFixed(2) == parseFloat(this.search).toFixed(2) ||
          searchPerson(el.employee, this.search)
      );
    },
  },
  methods: {
    update() {
      this.fetchData();
      this.$emit("update");
    },
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/invoice",
        query: `status=submittedSap`,
      });
      this.loading = false;
    },
    showDetails(id) {
      this.$router.push({
        name: "FinanceInvoicesSubmittedSapDetail",
        params: { id: id },
      });
    },
    showGroup(id) {
      this.$router.push({
        name: "FinanceInvoicesSubmittedSapGroup",
        params: { id: id },
      });
    },
  },
  async created() {
    await this.fetchData();
  },
});
</script>
